import { useAppSelector } from '@/shared/hooks/useStore';
import { selectUserData } from '@/viewmodel/features/user/state/userSlice';
import type { OnboardingCardViewState } from '@/viewmodel/features/user/types';

export function useOnboardingCardViewModel(): OnboardingCardViewState {
  const { data: user } = useAppSelector(selectUserData);
  return { showCard: user?.onboarded_at != null && user?.onboarding_completed_at == null };
}
